import * as yup from "yup";
export default yup.object().shape({
  // trading_name: yup.string().min(2).max(200).required("Required").label("Trading Name"),

  // company_registration_number: yup.number().required("Required").label("Company Registration Number"),

  // description: yup
  //   .string()
  //   .min(2)
  //   .max(1000)
  //   .required("Required")
  //   .label("Job description"),
  // startDate: yup
  //   .date()
  //   .max(new Date(), "Start date cannot be in the future")
  //   .nullable()
  //   .required("Required"),
  // endDate: yup
  //   .date()
  //   .when("startDate", (eventStartDate, schema) =>
  //     eventStartDate
  //       ? schema.min(eventStartDate, "End date cannot be before start date")
  //       : schema
  //   )
  //   .max(new Date(), "End date cannot be in the future")
  //   .nullable()
  //   .required("Required"),
  // skillNames: yup
  //   .array()
  //   .of(yup.string().max(30).label("A skill"))
  //   .required()
  //   .label("Skills developed"),
  // organisationId: yup.string().when("noResultInd", {
  //   is: false,
  //   then: yup.string().required("Required"),
  // }),
  // organisationName: yup
  //   .string()
  //   .when("noResultInd", {
  //     is: true,
  //     then: yup.string().min(2).max(50).required("Required"),
  //   })
  //   .label("Organisation name"),
  // organisationWebsite: yup
  //   .string()
  //   .when("noResultInd", {
  //     is: true,
  //     then: yup.string().min(2).max(100).required("Required"),
  //   })
  //   .label("Organisation website"),
  // primaryContactName: yup
  //   .string()
  //   .when("noResultInd", {
  //     is: true,
  //     then: yup.string().min(2).max(100).required("Required"),
  //   })
  //   .label("Primary contact name"),
  // primaryContactEmail: yup
  //   .string()
  //   .when("noResultInd", {
  //     is: true,
  //     then: yup.string().email().min(2).max(100).required("Required"),
  //   })
  //   .label("Primary contact email"),
});
